//@flow

import type {
  ActionType,
  TriggerFiltersFormValues,
  TriggerInitProvider,
  TriggerType,
} from '../../../../../../entities';
import {TRIGGER_TYPES, TRIGGER_TYPE_CONFIG} from '../../../utils/triggerConfig';

export const TRIGGER_FIELDS = {
  id: 'id',
  triggerType: 'triggerType',
  filters: 'filters',
  /** Local hour-slot value used in the UI; converted to UTC HH:MM on submit. */
  executionTimeSlot: 'executionTimeSlot',
  ruleWord: 'ruleWord',
  considerSimilarWord: 'considerSimilarWord',
  similarWord: 'similarWord',
  textPattern: 'textPattern',
  response: 'response',
  closeChatAfterResponse: 'closeChatAfterResponse',
  assignCollaborator: 'assignCollaborator',
  collaborator: 'collaborator',
  attachments: 'attachments',
  savedDocuments: 'savedDocuments',
  savedImages: 'savedImages',
  savedVideos: 'savedVideos',
  actionType: 'actionType',
  provider: 'provider',
  deviceId: 'deviceId',
  templateName: 'templateName',
  templateLang: 'templateLang',
  templateComponents: 'templateComponents',
};

export type TriggerFields = {
  id: string,
  triggerType: TriggerType,
  filters: TriggerFiltersFormValues,
  /** Local hour-slot (e.g. `08:00-05:00`); payload uses UTC `HH:MM`. */
  executionTimeSlot?: string,
  response: string,
  attachments: File[],
  savedDocuments: string[],
  savedImages: string[],
  savedVideos: string[],
  actionType: ActionType,
  provider?: TriggerInitProvider,
  deviceId?: string,
  templateName?: string,
  templateLang?: string,
  templateComponents?: any[],
};

export const TEXT_PATTERN_OPTIONS = [
  {
    value: 'MATCHES_WITH',
    label: 'Sea',
  },
  {
    value: 'BEGINS_WITH',
    label: 'Empieza con',
  },
  {
    value: 'INCLUDES',
    label: 'Contiene',
  },
  {
    value: 'ENDS_WITH',
    label: 'Termina con',
  },
];

export const TRIGGER_TYPE_OPTIONS = [
  {
    value: TRIGGER_TYPES.MESSAGE_RECEIVED,
    label: TRIGGER_TYPE_CONFIG[TRIGGER_TYPES.MESSAGE_RECEIVED].label,
  },
  {
    value: TRIGGER_TYPES.CUSTOMER_INACTIVITY,
    label: TRIGGER_TYPE_CONFIG[TRIGGER_TYPES.CUSTOMER_INACTIVITY].label,
  },
];
